import React from 'react';

import { useGridContext } from './context/GridContext';
import { GridRowContext } from './context/GridRowContext';
import { GridCells } from './GridCells';

import cn from './Grid.module.scss';

export const GridSummary = () => {
  const { summary, total_columns_width, start_index, row_height, theme } = useGridContext();
  return (
    <React.Fragment>
      {summary.map((row, index) => (
        <div
          key={`summary-${start_index}-${index}`}
          className={cn.row}
          style={{ height: `${row_height}px`, width: `${total_columns_width}px` }}
        >
          <GridRowContext.Provider value={{ row, index }}>
            <GridCells
              key={`summary-cells-${start_index}-${index}`}
              index={index}
              theme={theme.summary}
            />
          </GridRowContext.Provider>
        </div>
      ))}
    </React.Fragment>
  );
};
